// SPDX-License-Identifier: GPL-2.0-or-later
// Envelope: cada mensagem WebSocket binária carrega uma ou mais mensagens do catálogo, cada uma
// como [código u8][campos]. O decodificador nunca lança exceção: entrada inválida vira `{ ok: false }`.
import { ProtocolError, Reader, Writer } from './codec.js';
import { MESSAGES } from './messages.js';
/** Versão do protocolo web. Incrementar a cada mudança incompatível. */
export const PROTOCOL_VERSION = 4;
const BY_CODE = new Map();
for (const [name, def] of Object.entries(MESSAGES)) {
    if (BY_CODE.has(def.code))
        throw new Error(`código repetido no catálogo: ${def.code}`);
    BY_CODE.set(def.code, [name, def]);
}
function writeMessage(w, message) {
    const def = MESSAGES[message.type];
    if (!def)
        throw new RangeError(`mensagem desconhecida: ${String(message.type)}`);
    w.u8(def.code);
    const values = message;
    for (const [field, type] of Object.entries(def.fields))
        type.write(w, values[field]);
}
/** Codifica mensagens numa mensagem WebSocket. Valores fora da faixa lançam `RangeError` (bug de quem envia). */
export function encodeFrame(...messages) {
    const w = new Writer();
    for (const m of messages)
        writeMessage(w, m);
    return w.finish();
}
/**
 * Decodifica uma mensagem WebSocket. `dir` restringe a direção esperada (o servidor só aceita
 * mensagens c2s e vice-versa). Nunca lança exceção.
 */
export function decodeFrame(data, dir) {
    try {
        const r = new Reader(data);
        const messages = [];
        if (r.remaining === 0)
            return { ok: false, error: 'mensagem vazia' };
        while (r.remaining > 0) {
            const code = r.u8();
            const entry = BY_CODE.get(code);
            if (!entry)
                return { ok: false, error: `código desconhecido: ${code}` };
            const [name, def] = entry;
            if (dir && def.dir !== dir)
                return { ok: false, error: `${name}: direção ${def.dir} inesperada` };
            const out = { type: name };
            for (const [field, type] of Object.entries(def.fields))
                out[field] = type.read(r);
            messages.push(out);
        }
        return { ok: true, messages };
    }
    catch (error) {
        // ProtocolError = formato inválido; qualquer outra coisa também não pode derrubar o servidor
        return {
            ok: false,
            error: error instanceof ProtocolError
                ? error.message
                : `erro interno do decodificador: ${String(error)}`,
        };
    }
}
/** Mensagem pelo nome, com os campos tipados (atalho para montar mensagens). */
export function message(type, fields) {
    return { type, ...fields };
}
//# sourceMappingURL=frame.js.map